import { SocietyEquityMarketStatus } from 'types/Society';
import { EquityMarketAdminPanelContextType } from '../types/EquityMarketAdminPanelContextType';
import { tabs } from './Tabs';

export const equityMarketAdminPanelInitValue: EquityMarketAdminPanelContextType =
  {
    data: {
      societyId: '',
      societyName: '',
      equityMarketStatus: SocietyEquityMarketStatus.OPEN,
      tradingOffers: [],
      sellOffersCount: 0,
      buyOffersCount: 0,
      selectedTab: tabs.SELL,
      selectedTradingOfferOption: null,
      tradingOfferOptions: [],
      statusCounts: undefined,
      operations: [],
      tradingOfferOperationsCount: undefined,
      partners: [],
      isAdmin: false,
      isLoading: true,
    },
    actions: {
      handleGoBack: () => {},
      handleChangeOffersPage: () => {},
      handleChangeOffersRowsPerPage: () => {},
      handleChangeTab: () => {},
      handleChangeTradingOfferOption: () => {},
      handleSearchTradingOffer: () => Promise.resolve([]),
      handleEquityMarketStatusChange: () => {},
      handleViewOfferDetail: () => {},
      handleViewOperationDetail: () => {},
      handleTogglePartnerEquityMarketAccess: () => {},
    },
  };
